<template>
  <span
    class="placeholder-blocks"
    :class="{ flex }"
  >
    <div
      v-for="n in repeat"
      :key="n"
      :style="{ height, width: blockWidth() }"
      class="placeholder-block"
      data-testid="placeholder-block"
    />
    <slot />
  </span>
</template>

<script>

export default {
  props: {
    repeat: {
      type: Number,
      default: 1
    },
    width: {
      type: String,
      default: null
    },
    minwidthpercent: {
      type: Number,
      default: 1
    },
    height: {
      type: String,
      default: '20px'
    },
    flex: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    maxwidth() {
      return this.flex ? 100 / this.repeat : 100
    }
  },
  methods: {
    blockWidth() {
      return this.width || `${Math.floor(Math.random() * (this.maxwidth - this.minwidthpercent)) + this.minwidthpercent}%`
    }
  }
}
</script>

